import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
function _window() {
    return window;
}
// Window might not be available on every platform -> so make injectable wrapper
let WindowReference = class WindowReference {
    get nativeWindow() {
        return _window();
    }
};
WindowReference = __decorate([
    Injectable()
], WindowReference);
export { WindowReference };
